import {
  IGetCustomerNameByInnResponse,
  IMappers,
  IGetCustomerNameByInnRequest,
} from '../../../repositories/billing-accounts/v1/get-customer-name-by-inn';
import { IApplicationContext } from '../../../types/applicationContext';

export interface IGetCustomerNameByInnParamters {
  inn: IGetCustomerNameByInnRequest['inn'];
}

export enum EGetCustomerNameByInnStatus {
  CriticalError,
  Error,
  Pending,
  Success,
}

export interface IGetCustomerNameByInnResult {
  name: IGetCustomerNameByInnResponse['name'];
  message: string | null;
  status: EGetCustomerNameByInnStatus;
}

export type IGetCustomerNameByInnDependencies = Pick<IApplicationContext, 'logger' | 'httpApi'>;

export type IGetCustomerNameByInnMappers = IMappers<IGetCustomerNameByInnResult, IGetCustomerNameByInnResult>;
